import { ProjectsHeader as Header, Projects, Footer } from "../../components";
import "./ProjectsPage.css";

const ProjectsPage = () => {
  return (
    <>
      <Header />
      <Projects />
      <Footer />
    </>
  );
}

export { ProjectsPage };